export default function deepEqual(obj1: any, obj2: any) {
  // 如果是同一个引用，直接返回true
  if (obj1 === obj2) {
    return true;
  }

  // 如果其中一个是 null 或者它们的类型不同，返回 false
  if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  // 获取对象的所有键
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);

  // 如果键的数量不同，返回 false
  if (keys1.length !== keys2.length) {
    return false;
  }

  // 递归比较每个键的值
  for (let key of keys1) {
    // 确保 obj2 也有这个键
    if (!keys2.includes(key)) {
      return false;
    }

    // 递归比较每个属性的值
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  // 如果所有比较都通过，返回 true
  return true;
}
